import { IonItem } from '@ionic/react';
import React, { PropsWithChildren } from 'react';

export default function AccordionHeader({
  children,
}: PropsWithChildren & { className?: string }) {
  return (
    <IonItem slot="header" className="border-b">
      <p className="high-emphasis-text capitalize">{children}</p>
    </IonItem>
  );
}
